import { User } from './../../../../../types/tournament';
import { getDisplayName } from '../../../../../utils/userDisplayName';

export const getPlayerName = (user: User) => getDisplayName(user);